import { PropsWithChildren } from "react";
import { MDXProvider } from "@mdx-js/react";
import {
  PageLayout,
  FullWidthSection,
  Section,
  FlexColumns,
} from "../../mdx-pages/components/layout";
import {
  AccentText,
  SectionTitle,
} from "../../mdx-pages/components/typography";
import { mdxPage } from "../../mdx-pages/components/layout/styles.css";
import { Image } from "../../mdx-pages/components/content/image";
import { PercentValue } from "../../mdx-pages/components/content/percent-value";
import {
  TextLink,
  UnderlinedTextLink,
} from "../../mdx-pages/components/content/link";
import { TwoColumns } from "../../mdx-pages/components/layout/two-columns/TwoColumns";
import { BulletLIstItem } from "../../mdx-pages/components/content/bullet-list-item";
import { ItemsList } from "../../mdx-pages/components/layout/list";
import { PageProps } from "gatsby";
import { PersonCard } from "../../mdx-pages/components/content/person-card";
import { Footer } from "../../shared/components/layout/footer";
import { footer, pageTitle, pageTitleContainer } from "./styles.css";
import { Slideshow } from "../../mdx-pages/components/content/slideshow";

// Components can be used in MDX files without any imports
const shortcuts = {
  Section,
  FullWidthSection,
  SectionTitle,
  Image,
  PercentValue,
  FlexColumns,
  AccentText,
  UnderlinedTextLink,
  TwoColumns,
  BulletLIstItem,
  ItemsList,
  PersonCard,
  Slideshow,
  TextLink,
};

const scrollToTop = () =>
  window.scrollTo({ left: 0, top: 0, behavior: "smooth" });

export const MDXPagesLayout = ({
  children,
  props,
}: PropsWithChildren<{
  props: PageProps<unknown, { frontmatter?: { title?: string } }>;
}>) => {
  const title = props.pageContext.frontmatter?.title;

  return (
    <MDXProvider components={shortcuts}>
      <div className={mdxPage}>
        <div className={pageTitleContainer}>
          <div className={pageTitle}>{title}</div>
        </div>
        <PageLayout>{children}</PageLayout>
      </div>
      <Footer className={footer} onScrollToTop={scrollToTop} />
    </MDXProvider>
  );
};
